<template>
    <v-snackbar
            :multi-line="true"
            :timeout="$store.state.common.snackBarTimeout"
            :color="$store.state.common.snackBarColor"
            @input="$store.commit('clearSnackBar')"
            :value="$store.state.common.snackBarShow"
            class="snack-bar"
    >
        <div class="snack-bar__wrap">
            <div class="snack-bar__content">
                <div v-if="$store.state.common.snackBarMessageRaw" v-html="$store.state.common.snackBarMessageRaw"></div>
                <div v-else>{{ $store.state.common.snackBarMessage }}</div>
            </div>
            <div class="ml-4">
                <v-btn
                        @click="$store.commit('clearSnackBar')"
                        small
                        icon
                        light
                        dark
                        class="snack-bar__close"
                        elevation="0"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
        </div>
    </v-snackbar>
</template>

<script>
    export default {

    }
</script>

<style lang="scss">
    .snack-bar {
        .snack-bar__title {
          font-size: 18px;
          font-weight: 500;
          padding: 0 0 15px 0;
        }
        .snack-bar__wrap {
            width: 100%;
            display: flex;
            justify-content: space-between;
        }
        .snack-bar__content {
            display: flex;
            align-items: center;
            font-size: 14px;
        }
        .snack-bar__close {
            margin: 0 !important;
        }
    }
</style>